import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import {
  genericUnitField,
  ghgCategoryField,
  naicsCodeField,
} from './common/sharedFields';
import { msg } from '@lingui/core/macro';
import { locationCountryField } from './common/locationFields';
import { eeioModelKindField } from './common/sharedFields';
import { currencyQuantityField } from './common/expenditureFields';

export const ceeNaicsSpendMetadata = {
  displayName: msg({
    message: 'CEE NAICS spend',
    context: 'Activity data schema name for CEE NAICS spend',
  }),
  fields: {
    ...coreFields,
    ghg_category_id: ghgCategoryField,
    country: locationCountryField,
    eeio_model_kind: eeioModelKindField,
    inflation_adjustment_naics_code: {
      displayName: msg({
        message: 'Inflation adjustment industry code',
        context: 'The industry code used for inflation adjustment.',
      }),
      externalDescription: msg({
        message: 'The industry code used for inflation adjustment.',
        context: 'Inflation adjustment industry code',
      }),
    },
    naics_code: naicsCodeField,
    quantity: currencyQuantityField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
